<template>
    <div style="position: relative">
        <iframe v-if="this.version!=''" id="baidutongji" name="baidutongji"
        :src="`https://aiplugin.5118.com/Pluginstat/?p=OutLink&v=${version}`"
        style="width: 0; height: 0; position: fixed; transform: translateY(-9999px);"></iframe>

        <div dir="rtl" class="page">
            <div dir="ltr">
                <p class="checkdomainname" :title="getdomain">当前域名【{{getdomain}}】</p>
                <div class="row" style="margin: 10px 0;">
                    <div class="col-15 left" style="text-align: left;padding-bottom: 10px;;font-size: 12px;">
                        首页外链趋势
                    </div>
                    <a @click="jump_outlink(getdomain)" target="_blank">
                        <v-chart-2  title="首页外链" :data='getOutLinkChartData()' id="biadu-outlink" ></v-chart-2>
                    </a>
                    <div class="row" style="margin: 10px 0;">
                        <div @click="jump_outlink(getdomain)" class="col-15 left" style="text-align: center;color: gray;cursor: pointer;">
                            <p style="font-size: 20px;text-align: center;">{{latestfoundcount}}</p>
                            <p style="font-size: 12px;">最新一次发现数量</p>
                        </div>

                        <div @click="jump_outlink(getdomain)" class="col-15 right" style="text-align: center;color: gray;cursor: pointer;">
                            <p style="font-size: 20px;text-align: center;">{{comparelastcount}}</p>
                            <p style="font-size: 12px;">较上次</p>
                        </div>

                        <div class="dotted-line" style="padding-top: 60px;"></div>

                        <div style="color: #000;text-align: left;line-height: 20px;font-size: 13px;padding-bottom: 15px;padding-top: 15px;">
                            <span>TOP20个外链</span>
                        </div>


                        <table class="outlink-table" style="table-layout: fixed">
                            <thead>
                                <tr>
                                    <th>排名</th>
                                    <th>域名</th>
                                    <th>反链数</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="iscount" v-for="(item,index) in items" :key="index">
                                    <td style="padding-left: 8px;border-top: 1px dashed #ccc;">{{item.RowNum}}</td>
                                    <td :title="item.Url" @click="jump_outlink(item.Url)" style="cursor: pointer;border-top: 1px dashed #ccc;">{{item.Url}}</td>
                                    <td style="border-top: 1px dashed #ccc;">{{item.LinkCount}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="!iscount" style="height:100%;
                            position: relative;
                            margin-top: 50%;
                            font-size: 12px;
                            text-align: center;">
                            <img src="https://s0.5118.com/assist/images/formal/nosearchicon.png">
                            <p style="line-height: 25px;">由于该域名下子外链数量过大</p>
                            <p>该域名下的外链暂不开放查询</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="div-bottom">
            <button class="btn btn-bottom" @click="jump_outlink(getdomain)">查看更多外链</button>
        </div>
    </div>
</template>


<script>
  import {mapActions} from "vuex"
export default {
    name:"OutLink",
    data(){
        return{
            // iscount:true,
        }
    },
    computed: {
        items: {
            get() {
                return this.$store.state.outlink.items;
            },
            set(val) {
                this.$store.state.outlink.items = val
            }
        },
        datalist: {
            get() {
                return this.$store.state.outlink.datalist;
            },
            set(val) {
                this.$store.state.outlink.datalist = val
            }
        },
        comparelastcount: {
            get() {
                return this.$store.state.outlink.comparelastcount;
            },
            set(val) {
                this.$store.state.outlink.comparelastcount = val
            }
        },
        latestfoundcount: {
            get() {
                return this.$store.state.outlink.latestfoundcount;
            },
            set(val) {
                this.$store.state.outlink.latestfoundcount = val
            }
        },
        iscount: {
            get() {
                return this.$store.state.outlink.iscount;
            },
            set(val) {
                this.$store.state.outlink.iscount = val
            }
        },
        version:{
            get(){
            return this.$store.state.menu.version
            },
            set(val){
            this.$store.state.menu.version = val
            }
        },
        getdomain: {
            get() {
            return this.$store.state.menu.jump_domain_url;
            }
        }
    },
    mounted() {
      this.ASetHistory("outlink").then(flag => {
          if (flag) {
              this.listenOutLink();
          }

      });
    },
    methods: {
        ...mapActions("menu", ["ASetHistory"]),
        listenOutLink(){
            this.$messenger.addTarget(window.parent, 'parent');
            this.$messenger.targets['parent'].send("Out_Link_Send_Message");

            this.$messenger.listen("_5118_OutLink_List_info", (msg) => {
                if(msg)
                {
                    this.datalist=JSON.parse(msg).Trend.ChartJSON;
                    this.comparelastcount=JSON.parse(msg).Trend.CompareLastCount;
                    this.latestfoundcount=JSON.parse(msg).Trend.LatestFoundCount;
                    this.items=JSON.parse(msg).List.AhrefsList;
                    JSON.parse(msg).List.RowCount!=-1?this.iscount=true:this.iscount=false;
                }

            });
        },
        getOutLinkChartData() {
            if(this.datalist.length>0)
            {
                 return JSON.parse(this.datalist);
            }
            else
            {
                return {"date":[],"result":[]}
            }

        },
        jump_outlink(url){
            window.open('https://ahrefs.5118.com/'+url);
        }
    }
}
</script>



<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  .outlink-table {
    width: 100%;
    border: none;
    border-top: 1px solid #ccc;
    td, th {
      border: none;
      text-align: left;
      line-height: 26px;
      font-size: 12px;
      font-weight: normal;
      .ellipsis();
      &:nth-child(1) {
        width: 20%;
      }
      &:nth-child(2) {
        width: 60%;
      }
      &:nth-child(3) {
        width: 20%;
      }
    }
    td {
      &:nth-child(2) {
        color: @theme-color;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/OutLink.vue